app.service('accountView', function (main, complaintHistory, permissionsBox, loading, message, localStorage, accountChangePaymentView,
	announcementModal, modal, ePaymentBlikModal, front, deliveryTracking, accountWarrantiesManager,
	customerPersonalDataVerificationModal, subscriptionPayments, subscriptionInvoices, accountConfig, kredytLineRedirect, accountCartRetrieve,
	warrantyUpsellingBox, countdownTimer, subscriptionWarranties, subscriptionServices, warrantyUpsellingPayment) {
	var config;
	function getMessageKey(complaintType) {
		if (complaintType === "RECLAMATION") {
			return 'complaint-history-reclamation-date-message';
		}
		return 'complaint-history-return-date-message';
	}
	function initPayUOfferModal(){
		var $showPayuOfferButton = $('.js-show-payu-offer-modal');
		var modalId = $showPayuOfferButton.data('payu-offer-modal-id');
		if($showPayuOfferButton.length) {
			$showPayuOfferButton.on('click', function(){
				modal.open('about-payu-instalments'+ (modalId != '' ? '-'+modalId : ''));
			});
		}
	}
	function init() {
		if (!front.katalog) {
			if (front.page() === 'complaint-history') {
				complaintHistory.init();
			} else if (front.page() === 'subscription-payments') {
				subscriptionPayments.init();
			} else if (front.page() === 'customer-subscription-invoices') {
				subscriptionInvoices.init();
			} else if (front.page() === 'change-payment' || front.page() === 'change-time') {
				accountChangePaymentView.init();
			}

			if (front.page() === 'warranty-upselling-payment') {
				warrantyUpsellingPayment.init();
			}

			if (front.page() === 'order-preview') {
				warrantyUpsellingBox.init();
			}

			if (front.page() === 'order-list-active' || front.page() === "account-main-page") {
				$('.warranty-upselling-list-box').each(function () {
					let $box = $(this);
					countdownTimer.create($box.find('.js-upselling-counter'), {
						onEnd() {
							$box.hide();
						}
					});
				});
			}

			if (front.page() === "account-main-page") {
				subscriptionWarranties.checkForAccountOverdueSubscriptions();
				subscriptionServices.checkForAccountOverdueSubscriptions();
				customerPersonalDataVerificationModal.init();
			}
			if (front.page() === "account-main-page" || front.page() === 'order-list-active' || front.page() === 'order-preview') {
				accountWarrantiesManager.init();
			}

			if (front.page() === "account-main-page" || front.page() === 'order-list-active' || front.page() === 'order-preview' || front.page() === 'subscription-payments') {
				ePaymentBlikModal.init();
			}

			if (front.page() === "account-main-page" || front.page() === 'order-list-active' || front.page() === 'order-preview' || front.page() === 'change-payment') {
				initPayUOfferModal();
			}

			if (front.page() === "order-preview") {
				config = accountConfig.getData();
				if(config.ePaymentType){
					if(config.ePaymentBlik){
						ePaymentBlikModal.load(config.ePaymentType, config.orderNumber);
					}else if(config.ePaymentType === 'TPay'){
						goToTPayAlertRedirectVersion(config.toEPaymentTimeCount, config.orderNumber); // Metoda pochodzi ze starego kodu, jednak jej użycie jest mniej pracochłonnym zadaniem
					}else{
						goToEcardAlert(config.toEPaymentTimeCount, '#LayerPlatnosci'); // Metoda pochodzi ze starego kodu, jednak jej użycie jest mniej pracochłonnym zadaniem
					}
				}
			}

			$('body').on('click', '.js-complaint-history-date-info', function () {
				const complaintType = $(this).data('complaint-type');
				const messageKey = getMessageKey(complaintType);
				message.alert(messageKey);
			}).on('click', '.js-kredytLine-redirect-init', function () {
				var orderNr = $(this).data('order-number');
				kredytLineRedirect.redirect({
					orderNumber: orderNr
				});
			}).on('click', '.js-cart-retrive-action', function () {
				var $this = $(this);
				accountCartRetrieve.action($this.data('action'), $this.data('cart'));
			});

			deliveryTracking.init();
			permissionsBox.init();
			announcementModal.init();
			if ($('#customer-account-error-data').length && localStorage.getItem('customer-account-error-data') !== 's') {
				message.get('account - no-all-account-data').then(function (html) {
					modal.generate({
						content: html,
						id: 'no-all-account-data',
						buttons: [{
							text: 'Uzupełnij brakujące dane',
							click: function () {
								loading.redirect($('#customer-account-error-data a.button').attr('href'));
							}
						}]
					});
					localStorage.setItem('customer-account-error-data', 's');
				});
			}
		}
	}

	permissionsBox.checkPermissions();
	main.onLoad(init);
	$(document).on('pageChange', init);
});
